// v16.6 — Avatar helper (frontend).
//
// Xác định user có đang dùng avatar mặc định (chưa upload ảnh thật) hay không.
// Song song với backend `/app/backend/user_avatar.py` — giữ danh sách pattern
// đồng bộ. Data URL (`data:image/...`) luôn coi là ảnh thật.

const DEFAULT_AVATAR_HOST_SUBSTRINGS = [
  "api.dicebear.com",
  "ui-avatars.com",
  "gravatar.com/avatar",
  "placeholder.picklehub",
  "avatar.picklehub/default",
];

export function isDefaultAvatarUrl(url) {
  if (url == null) return true;
  const s = String(url).trim();
  if (!s) return true;
  const lowered = s.toLowerCase();
  if (lowered.startsWith("data:")) return false;
  return DEFAULT_AVATAR_HOST_SUBSTRINGS.some((h) => lowered.includes(h));
}

/** True nếu user CHƯA upload avatar thật (đang dùng ảnh mặc định). */
export function hasNoCustomAvatar(user) {
  if (!user) return true;
  return isDefaultAvatarUrl(user.avatar_url);
}
